import { socialLoginDomain } from "../constants/hosts";
import { DU_STORE_CODE } from "../constants/store";
import { loadScript } from "./functions";

declare global {
    interface Window {
        showSocialButtons: any;
        _providersContainerID: any;
    }
}
export function socialLogin(noloop = false, callback?:Function) {
    if (document.getElementById(window._providersContainerID)) {
        window.showSocialButtons(DU_STORE_CODE, '', 'home2019.css');
        callback && callback();
    } else {
        
        if (noloop) {
            return;
        }
        
        // Using generic script loader.
        loadScript(socialLoginDomain, 'sociallogin', () => {
            socialLogin(true, callback);
        });
    }
}